module.exports = __webpack_public_path__ + "fdb21673f89cbd3dc6251324102d6a11.png";